import axiosClient from "@/libs/axiosClient";

export const _alertRuleTest = data => {
    return axiosClient.post(`/validate/alertruletest`, data);
};



// WEBPACK FOOTER //
// ./src/api/alertrules.js